import { ListItem, withStyles } from '@material-ui/core';

/**
 * Styled components for the BaseDropdown component
 * Updated to match Figma design specifications
 */

// Styling constants
const COLORS = {
  hover: '#f6f6f6',
  selected: '#ffffff',
  disabled: '#f5f5f5',
  disabledText: '#ccc'
} as const;

const DIMENSIONS = {
  padding: '6px 12px',
  borderRadius: '22px',
  minHeight: '44px'
} as const;

export const StyledListItem = withStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: DIMENSIONS.padding,
    borderRadius: DIMENSIONS.borderRadius,
    minHeight: DIMENSIONS.minHeight,
    transition: 'background-color 0.2s ease-in-out',
    cursor: 'pointer',
    backgroundColor: '#ffffff',
    marginBottom: '4px', // Gap between items from Figma
    '&:last-child': {
      marginBottom: 0
    },
    '&:hover': {
      backgroundColor: COLORS.hover
    },
    '&:focus': {
      backgroundColor: COLORS.hover,
      outline: 'none'
    },
    '&.selected': {
      backgroundColor: COLORS.selected
    },
    '&.selected:hover': {
      backgroundColor: COLORS.hover
    },
    '&.disabled': {
      backgroundColor: COLORS.disabled,
      color: COLORS.disabledText,
      cursor: 'not-allowed',
      '&:hover': {
        backgroundColor: COLORS.disabled
      }
    }
  }
})(ListItem);
